import { FC } from "react";
import { Formik } from "formik";

import ForgotPasswordForm from "./ForgetPasswordForm";

import { logger } from "../../../../utils/logger";
import { forgetPassValidationSchema } from "../utils";

const ForgotPassword: FC = (): JSX.Element => {

    return (
        <Formik
            initialValues={{ email: '' }}
            validationSchema={forgetPassValidationSchema}
            onSubmit={(values, { setSubmitting }) => {
                logger.log(values);
            }}
        >
            <ForgotPasswordForm />
        </Formik>
    )
}

export default ForgotPassword;